export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14104.ab4d505d.jpg";